<section *transloco="let t" class="pt-6 pb-12 sm:pt-12 sm:pb-24">
  <!-- Title & Subtitle -->
  <div class="mx-auto max-w-4xl text-center">
    <h2 class="text-3xl font-extrabold leading-tight tracking-tight text-slate-900 sm:text-5xl">
      {{ t('home.partners.title') }}
    </h2>
    <p class="mt-4 text-base text-slate-600 sm:text-xl">
      {{ t('home.partners.subtitle') }}
    </p>
  </div>

  <!-- Auto-Scrolling -->
  <div class="marquee mt-10 sm:mt-14">
    <ul class="marquee-track items-center gap-10 sm:gap-16">
      @for (partner of marquee; track $index) {
        <li class="flex shrink-0 items-center">
          <img
            [src]="partner.logo"
            [alt]="partner.name"
            loading="lazy"
            class="h-24 w-auto object-contain sm:h-28"
          />
        </li>
      }
    </ul>
  </div>
</section>
